import { Modal, Text } from '@pinchenterprisesnpm/friday-ui'
import { StableScrollableModalContent as Content } from 'ui/components/common/style'
import { RadioGroup } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/radio-group'

const { Header } = Modal

interface IAcceptanceCriteriaModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const AcceptanceCriteriaModal = ({ isOpen, closeModal }: IAcceptanceCriteriaModalProps) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} width='800px'>
      <Header title='Edit Acceptance Criteria' />

      <Content>
        <Text px='sm'>All Upshifters are pre-vetted and have passed background checks.</Text>

        <RadioGroup />
      </Content>
    </Modal>
  )
}
